import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import getTranslation from '../../../strings/i18n';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { StyledFlex } from '../../../styles/common';
import { StyledText } from '../../../styles/text';
import { StyledLabel } from '../subcomponents';
var OfferDetails = function (_a) {
    var option = _a.option;
    var tryT = getTranslation().tryT;
    return (_jsx(_Fragment, { children: [
            {
                key: 'annualPercentageRate',
                prefix: '',
                suffix: '%'
            },
            {
                key: 'estimatedInterestAmount',
                prefix: '$',
                suffix: ''
            },
            {
                key: 'estimatedTotalAmount',
                prefix: '$',
                suffix: ''
            }
        ].map(function (_a) {
            var key = _a.key, prefix = _a.prefix, suffix = _a.suffix;
            return (_jsxs(StyledFlex, { direction: "column", children: [_jsx(StyledLabel, { size: "small", lineHeight: "1.2", children: tryT("selectPay.".concat(key, "Label")).toUpperCase() }), _jsx(Stack, { size: "small" }), _jsx(StyledText, { weight: "bold", children: "".concat(prefix).concat(option[key]).concat(suffix) })] }, key));
        }) }));
};
export default OfferDetails;
//# sourceMappingURL=index.js.map